/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorMostRead from 'base/components/labrador/MostRead';

export const DynamicLabradorMostRead: typeof LabradorMostRead = (props) => {
    return <ErrorBoundary><LabradorMostRead {...props} /></ErrorBoundary>;
}
export type DynamicLabradorMostReadProps = PropsFromComponent<typeof LabradorMostRead>;
